import Vue from "vue";
import swal, { confirm, toast } from "../modules/shared/helpers/swal";

Object.defineProperties(Vue.prototype, {
  $swal: {
    get() {
      return swal;
    },
  },
});
Object.defineProperties(Vue.prototype, {
  $confirm: {
    get() {
      return confirm;
    },
  },
});
Object.defineProperties(Vue.prototype, {
  $toast: {
    get() {
      return toast;
    },
  },
});
